import { useRouter } from "next/router";

interface CustomerLogo {
  name: string;
  src: string;
  scale: number;
  href: string;
}

const customerLogos: Record<string, CustomerLogo> = {
  block: {
    name: "Block",
    src: "/img/customers/customer-block.png",
    scale: 1.125,
    href: "https://block.xyz/",
  },
  shopify: {
    name: "Shopify",
    src: "/img/customers/customer-shopify.svg",
    scale: 1,
    href: "https://www.shopify.com/",
  },
  airbnb: {
    name: "Airbnb",
    src: "/img/customers/customer-airbnb.svg",
    scale: 1.1,
    href: "https://airbnb.com/",
  },
  sweetgreen: {
    name: "sweetgreen",
    src: "/img/customers/customer-sweetgreen.svg",
    scale: 0.875,
    href: "https://www.sweetgreen.com/",
  },
  figma: {
    name: "Figma",
    src: "/img/customers/customer-figma.svg",
    scale: 0.75,
    href: "https://figma.com/",
  },
  everlane: {
    name: "Everlane",
    src: "/img/customers/customer-everlane.svg",
    scale: 0.85,
    href: "https://everlane.com/",
  },
  stripe: {
    name: "Stripe",
    src: "/img/customers/customer-stripe.svg",
    scale: 1.1,
    href: "https://stripe.com/",
  },
  imperfect: {
    name: "Imperfect Foods",
    src: "/img/customers/customer-imperfect.png",
    scale: 1.75,
    href: "https://www.imperfectfoods.com/",
  },
  warby: {
    name: "Warby Parker",
    src: "/img/customers/customer-warby.svg",
    scale: 1.0625,
    href: "https://www.warbyparker.com/",
  },
  vimeo: {
    name: "Vimeo",
    src: "/img/customers/customer-vimeo.svg",
    scale: 1,
    href: "https://vimeo.com/",
  },
  expensify: {
    name: "Expensify",
    src: "/img/customers/customer-expensify.svg",
    scale: 0.9,
    href: "https://expensify.com/",
  },
  doordash: {
    name: "DoorDash",
    src: "/img/customers/customer-doordash.svg",
    scale: 0.9,
    href: "https://doordash.com/",
  },
  klarna: {
    name: "Klarna",
    src: "/img/customers/customer-klarna.svg",
    scale: 0.7,
    href: "https://klarna.com/",
  },
  twitter: {
    name: "Twitter",
    src: "/img/customers/customer-twitter.svg",
    scale: 1,
    href: "https://twitter.com/",
  },
  wise: {
    name: "Wise",
    src: "/img/customers/customer-wise.svg",
    scale: 0.7,
    href: "https://wise.com/",
  },
  mongodb: {
    name: "MongoDB",
    src: "/img/customers/customer-mongodb.svg",
    scale: 1.3,
    href: "https://www.youtube.com/watch?v=CeFP3Gm7aGc",
  },
  servicenow: {
    name: "ServiceNow",
    src: "/img/customers/customer-servicenow.svg",
    scale: 0.875,
    href: "https://servicenow.com/",
  },
  flexport: {
    name: "Flexport",
    src: "/img/customers/customer-flexport.png",
    scale: 0.8,
    href: "https://flexport.com/",
  },
  monzo: {
    name: "Monzo",
    src: "/img/customers/customer-monzo.svg",
    scale: 2.1,
    href: "https://monzo.com/",
  },
  zynga: {
    name: "Zynga",
    src: "/img/customers/customer-zynga.svg",
    scale: 0.8,
    href: "https://zynga.com/",
  },
  ziprecruiter: {
    name: "ZipRecruiter",
    src: "/img/customers/customer-ziprecruiter.svg",
    scale: 1.15,
    href: "https://ziprecruiter.com/",
  },
  revolut: {
    name: "Revolut",
    src: "/img/customers/customer-revolut.svg",
    scale: 0.7,
    href: "https://revolut.com/",
  },
  calm: {
    name: "Calm",
    src: "/img/customers/customer-calm.png",
    scale: 1,
    href: "https://www.calm.com/",
  },
  boom: {
    name: "Boom",
    src: "/img/customers/customer-boom.png",
    scale: 1,
    href: "https://boomsupersonic.com/",
  },
  samsara: {
    name: "Samsara",
    src: "/img/customers/customer-samsara.svg",
    scale: 0.95,
    href: "https://samsara.com/",
  },
  zendesk: {
    name: "Zendesk",
    src: "/img/customers/customer-zendesk.svg",
    scale: 0.66,
    href: "https://zendesk.com/",
  },
  meundies: {
    name: "MeUndies",
    src: "/img/customers/customer-meundies.svg",
    scale: 0.75,
    href: "https://meundies.com/",
  },
  dataiku: {
    name: "Dataiku",
    src: "/img/customers/customer-dataiku.svg",
    scale: 1.25,
    href: "https://www.dataiku.com/",
  },
  misfits: {
    name: "Misfits Market",
    src: "/img/customers/customer-misfits.svg",
    scale: 0.95,
    href: "https://www.misfitsmarket.com/",
  },
  pressed: {
    name: "Pressed Juicery",
    src: "/img/customers/customer-pressed.svg",
    scale: 0.85,
    href: "https://pressed.com/",
  },
  sonder: {
    name: "Sonder",
    src: "/img/customers/customer-sonder.svg",
    scale: 1,
    href: "https://sonder.com/",
  },
  segment: {
    name: "Segment",
    src: "/img/customers/customer-segment.svg",
    scale: 0.9,
    href: "https://segment.io/",
  },
  newrelic: {
    name: "New Relic",
    src: "/img/customers/customer-newrelic.svg",
    scale: 0.85,
    href: "https://newrelic.com/",
  },
  eventbrite: {
    name: "Eventbrite",
    src: "/img/customers/customer-eventbrite.svg",
    scale: 0.75,
    href: "https://eventbrite.com/",
  },
  spotify: {
    name: "Spotify",
    src: "/img/customers/customer-spotify.svg",
    scale: 1.2,
    href: "https://spotify.com/",
  },
  hopin: {
    name: "Hopin",
    src: "/img/customers/customer-hopin.svg",
    scale: 0.95,
    href: "https://hopin.com/",
  },
  yelp: {
    name: "Yelp",
    src: "/img/customers/customer-yelp.svg",
    scale: 1.5,
    href: "https://yelp.com/",
  },
  coupa: {
    name: "Coupa",
    src: "/img/customers/customer-coupa.svg",
    scale: 1,
    href: "https://coupa.com/",
  },
  ebanx: {
    name: "Ebanx",
    src: "/img/customers/customer-ebanx.svg",
    scale: 0.7,
    href: "https://ebanx.com/",
  },
  datadog: {
    name: "Datadog",
    src: "/img/customers/customer-datadog.svg",
    scale: 1.25,
    href: "https://datadog.com/",
  },
  digitalocean: {
    name: "DigitalOcean",
    src: "/img/customers/customer-digitalocean.svg",
    scale: 1,
    href: "https://digitalocean.com/",
  },
  okta: {
    name: "Okta",
    src: "/img/customers/customer-okta.svg",
    scale: 0.75,
    href: "https://okta.com/",
  },
  onfido: {
    name: "Onfido",
    src: "/img/customers/customer-onfido.svg",
    scale: 0.875,
    href: "https://onfido.com/",
  },
  pinterest: {
    name: "Pinterest",
    src: "/img/customers/customer-pinterest.svg",
    scale: 1.125,
    href: "https://pinterest.com/",
  },
  workos: {
    name: "WorkOS",
    src: "/img/customers/customer-workos.svg",
    scale: 0.8,
    href: "https://workos.com/",
  },
  kainos: {
    name: "Kainos",
    src: "/img/customers/customer-kainos.png",
    scale: 0.75,
    href: "https://kainos.com",
  },
  taskus: {
    name: "TaskUs",
    src: "/img/customers/customer-taskus.png",
    scale: 0.875,
    href: "https://taskus.com",
  },
  verkada: {
    name: "Verkada",
    src: "/img/customers/customer-verkada.svg",
    scale: 0.75,
    href: "https://verkada.com",
  },
  squareRoots: {
    name: "Square Roots",
    src: "/img/customers/customer-squareRoots.svg",
    scale: 0.85,
    href: "https://www.squarerootsgrow.com/",
  },
  dailyHarvest: {
    name: "Daily Harvest",
    src: "/img/customers/customer-dailyHarvest.svg",
    scale: 1,
    href: "https://www.daily-harvest.com/",
  },
  zuora: {
    name: "Zuora",
    src: "/img/customers/customer-zuora.svg",
    scale: 0.55,
    href: "https://zuora.com/",
  },
  walmart: {
    name: "Walmart",
    src: "/img/customers/customer-walmart.svg",
    scale: 1,
    href: "https://walmart.com",
  },
  generalAtlantic: {
    name: "General Atlantic",
    src: "/img/customers/customer-generalAtlantic.svg",
    scale: 0.9,
    href: "https://www.generalatlantic.com/",
  },
  atomico: {
    name: "Atomico",
    src: "/img/customers/customer-atomico.svg",
    scale: 0.75,
    href: "https://www.atomico.com/",
  },
  tiger: {
    name: "Tiger Global",
    src: "/img/customers/customer-tiger.svg",
    scale: 1,
    href: "https://www.tigerglobal.com/",
  },
  fortress: {
    name: "Fortress Investment Group",
    src: "/img/customers/customer-fortress.svg",
    scale: 0.9,
    href: "https://www.fortress.com",
  },
  generalCatalyst: {
    name: "General Catalyst",
    src: "/img/customers/customer-generalCatalyst.svg",
    scale: 1,
    href: "https://www.generalcatalyst.com/",
  },
};

function getCustomers(keys: string) {
  return keys
    .trim()
    .split(/\s+/)
    .map((key) => customerLogos[key]);
}

const customerSets: Record<
  string,
  Record<"home" | "customers" | "demo" | "finance", string>
> = {
  "en-US": {
    home: `
    block shopify airbnb sweetgreen twitter everlane
    stripe warby imperfect spotify doordash expensify
    klarna digitalocean servicenow pinterest flexport wise
    `,
    // block shopify doordash klarna kainos taskus
    customers: `
    airbnb stripe everlane pinterest warby expensify
    vimeo twitter eventbrite wise digitalocean imperfect 
    servicenow flexport spotify mongodb zendesk ziprecruiter 
    calm boom newrelic sonder hopin misfits
    monzo okta meundies segment figma revolut
    workos datadog zynga pressed ebanx dataiku
    `,
    // onfido verkada squareRoots coupa dailyHarvest zuora
    demo: `
    block shopify airbnb
    sweetgreen everlane zynga
    stripe imperfect twitter
    expensify doordash pinterest
    warby wise flexport
    spotify mongodb klarna
    sonder segment vimeo
    calm servicenow zendesk
    `,
    finance: `generalAtlantic atomico tiger fortress generalCatalyst`,
  },
  "en-GB": {
    home: `
    shopify atomico airbnb klarna wise onfido
    stripe monzo spotify revolut okta vimeo
    dataiku twitter hopin servicenow pinterest verkada
    `,
    customers: `
    airbnb klarna wise hopin spotify monzo
    revolut twitter stripe dataiku atomico block
    vimeo okta verkada onfido flexport servicenow
    meundies digitalocean zendesk pinterest calm expensify
    imperfect segment newrelic ebanx figma ziprecruiter
    sonder doordash everlane boom warby zynga
    `,
    demo: `
    monzo shopify airbnb
    hopin block klarna
    onfido okta revolut 
    stripe verkada spotify
    wise mongodb twitter
    servicenow flexport dataiku
    vimeo segment expensify
    doordash zendesk pinterest
    `,
    finance: `generalAtlantic atomico tiger fortress generalCatalyst`,
  },
};

function useCustomerSet(
  area: "home" | "customers" | "demo" | "finance"
): Array<CustomerLogo> {
  const { locale } = useRouter();
  return getCustomers(customerSets[locale][area]);
}

export default useCustomerSet;
